export default __webpack_public_path__ + "static/media/icon-empty-activity.592c272e.svg";